import { useState } from 'react';
import axios from 'axios';
import { BASE_URL } from '../constants/urls';

export default function useSignin() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

    const signin = async ( email,password, name ) => {
        setLoading(true);
        setError(null);

        try {
                const response = await axios.post(`${BASE_URL}/users`, {
                    email,
                    password,
                    name
                }, 
                {
                    headers: {
                        Authorization: `Bearer ${process.env.REACT_APP_API_TOKEN}`,
                    },
                }
            );

            setLoading(false);
            return response;
        } catch (err) {
            setLoading(false);
            console.log(err)
            setError(err.response.data.message);
            return null;
        }
    };

  return { signin, loading, error };
}
